import { useSpring, animated as a } from "@react-spring/web";
import { Html } from "@react-three/drei";
import { useRive } from "@rive-app/react-canvas";
import { useEffect, useMemo } from "react";
import { findChildStartsWithKey } from "../../../../utils/FindObjects";
import { MarkerLabels } from "../../../ui/MarkerLabel";
import { useTranslation } from "react-i18next";
import { MountWithEbbne } from "@solidwhite/ebbnen";
import { UIPortal } from "@solidwhite/ui-portal";

const DynamicChargeApplication = ({ object3d, ...props }) => {
  const flashTarget = useMemo(() => {
    return findChildStartsWithKey("rive_position_p_app_dynamic", object3d);
  }, []);
  const flashTarget2 = useMemo(() => {
    return findChildStartsWithKey("rive_position_p_app_dynamic2", object3d);
  }, []);

  const marker = useMemo(() => {
    return findChildStartsWithKey("markers_a_dynamiccharge", object3d);
  }, []);

  return (
    <>
      <FlashAnimation riveSrc="./assets/rive/enrx_flash.riv" position={flashTarget.position} />
      <FlashAnimation batteryStyle riveSrc="./assets/rive/enrx_battery.riv" position={flashTarget2.position} />
      <MarkerLabels node={marker} />
      <MountWithEbbne>
        <UIPortal>
          <DescriptionBox key="dynamic-description" />
        </UIPortal>
      </MountWithEbbne>
    </>
  );
};

const DescriptionBox = ({ visible = false }) => {
  const { t } = useTranslation();

  const { opacity } = useSpring({
    opacity: visible ? 1 : 0,
  });

  return (
    <a.div
      style={{
        opacity: opacity,
        position: "absolute",
        bottom: "4vw",
        left: "2vw",
      }}
    >
      <h3 style={{ color: "#37a46e", fontSize: "0.9vw" }}>{t("L4_CHARGE_APPLICATIONS_DYNAMICCHARGE_INTEROP")}</h3>
      <div
        style={{
          display: "flex",
          padding: "2vw 2.5vw",
          alignItems: "center",
          backgroundColor: "rgba(0, 0, 0, 0.45)",
          backdropFilter: "blur(10px)",
        }}
      >
        <DescriptionText>L4_CHARGE_APPLICATIONS_DYNAMICCHARGE_POWERLEVELS</DescriptionText>
        <DescriptionText>L4_CHARGE_APPLICATIONS_DYNAMICCHARGE_DISTANCE</DescriptionText>
        <DescriptionText>L4_CHARGE_APPLICATIONS_DYNAMICCHARGE_COMBINATION</DescriptionText>
        <DescriptionText last>L4_CHARGE_APPLICATIONS_DYNAMICCHARGE_COILTYPO</DescriptionText>
      </div>
    </a.div>
  );
};

const DescriptionText = ({ children, last = false }) => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        maxWidth: "12vw",
        color: "#fff",
        fontSize: "0.8vw",
        paddingRight: last ? 0 : "3vw",
      }}
      dangerouslySetInnerHTML={{ __html: t(children) }}
    >
      {/* {t(children)} */}
    </div>
  );
};

const FlashAnimation = ({ riveSrc, batteryStyle, ...props }) => {
  const revealSpring = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    config: { duration: 2000 },
  });

  const { rive, RiveComponent } = useRive({
    src: riveSrc,
    autoplay: false,
  });

  useEffect(() => {
    rive && rive.play();
  }, [rive]);

  return (
    <group {...props}>
      {/* <mesh>
        <sphereGeometry args={[0.1]} />
      </mesh> */}
      <Html
        style={{
          pointerEvents: "none",
        }}
      >
        <a.div
          style={{
            width: batteryStyle ? "8vw" : "15vw",
            height: "20vw",
            transform: "translate(-50%,-50%)",

            opacity: revealSpring.opacity,
          }}
        >
          <RiveComponent />
        </a.div>
      </Html>
    </group>
  );
};

export default DynamicChargeApplication;
